// extracted by mini-css-extract-plugin
export default {"bEntityTag":"BPatentTechnologyItem-module_bEntityTag_c45e8978"};